import { Injectable } from '@angular/core';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MOCK_STATUS, MOCK_URL_STOPOVERS, URL_STOPOVER} from '@ibe.config';
import { INDRABFMStopoverResponse, INDRABFMStopoverRequestParam } from '@ibe.models/stopover.indra.model';

@Injectable({
	providedIn: 'root'
})
export class INDRAStopoverService {

	confirmedStopovers: Array<any> = [];

	constructor(private api: INDRAApiService, private http: HttpClient) {
	}

	getStopover(params: INDRABFMStopoverRequestParam): Observable<INDRABFMStopoverResponse> {
		if (MOCK_STATUS.STOPOVER) {
			return this.getMockData(params);
		} else {
			return this.api.INDRA_post<INDRABFMStopoverResponse>(URL_STOPOVER, params);
		}
	}

	getMockStopover(params: INDRABFMStopoverRequestParam): Observable<INDRABFMStopoverResponse> {
		return this.getMockData(params);
	}

	getMockData(params: INDRABFMStopoverRequestParam) {
		return this.http.get<INDRABFMStopoverResponse>(MOCK_URL_STOPOVERS);
	}

	isStopoverConfirmed(route: string, routeType: string) {
		return this.confirmedStopovers.find(stopOver => stopOver.route === route && stopOver[routeType]);
	}

	clearStopoverConfirmed(): void {
		this.confirmedStopovers = [];
	}
}
